import { render, staticRenderFns } from "./upload-file.pug?vue&type=template&id=3f428ed8&lang=pug&"
import script from "./upload-file.ts?vue&type=script&lang=ts&"
export * from "./upload-file.ts?vue&type=script&lang=ts&"
import style0 from "./upload-file.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports